import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { ProduitComponent } from '../../../../pages/produit/produit.component';
import { Produit } from '../../model/produit';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { isDefined } from '@angular/compiler/src/util';
import { Inventaire } from '../../model/inventaire';
import { SettingService } from '../setting-service';
import { ProduitService } from '../produit/produit-service';



@Injectable()
export class InventaireService {

  inventaires: Inventaire[];

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public produitService: ProduitService,
              public sharedMethods: SharedMethods,
              public settingService: SettingService,
              ) { }

  getInventaire(from: string, to: string) {
    this.iSconnecting = true;
    return new Promise<Inventaire[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_INVENTAIRE(from, to),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Inventaire[]) => {
            const plans = plainToClass(Inventaire, data);
            this.inventaires = plans;
            resolve(plans);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  saveInventaire(inventaire: Inventaire) {

    this.iSconnecting = true;

    const body = {
      dateCreate: this.sharedMethods.converStringToDatetime(this.produitService.dateGeneInventaire),
      reference: inventaire.reference,
      products: inventaire.products,
      state: inventaire.state,

    };


    if (inventaire.id !== 0) {

      this.iSconnecting = true;

      return new Promise<Inventaire>(resolve => {
        this.http.put(this.apiEndpoints.GET_URL_PUT_INVENTAIRE(inventaire.id), body,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Inventaire) => {

              this.getInventaire(this.settingService.fromInventory, this.settingService.toInventory).then( () => {
                resolve(data);
                this.iSconnecting = false;
              });

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<Inventaire>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_INVENTAIRE, body,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Inventaire) => {
              this.getInventaire(this.settingService.fromInventory, this.settingService.toInventory).then( () => {
                resolve(data);
                this.iSconnecting = false;
              });
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  }

  deleteInventaire(inventaire: Inventaire) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_INVENTAIRE(inventaire.id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            this.getInventaire(this.settingService.fromInventory, this.settingService.toInventory).then( () => {
              resolve(data);
              this.iSconnecting = false;
            });

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }



}
